module.exports = __webpack_public_path__ + "static/media/btn_edit_left_back.e7e1a028.svg";